import { footerLinks } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id='footer' className='bg-background-900 text-background-100 pt-10 md:pt-16 pb-6 md:pb-8 px-4 md:px-6'>
      <div className='w-full max-w-6xl mx-auto'>
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8 md:mb-12'>
          <div>
            <div className='flex items-center gap-2 mb-4'>
              <span className='w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center'>
                <i className='ri-movie-2-line text-background-50 text-lg'></i>
              </span>
              <span className='font-heading text-lg font-bold text-background-50'>97在线影院</span>
            </div>
            <p className='text-sm text-background-300 leading-relaxed mb-4'>
              {footerLinks.about}
            </p>
          </div>

          {footerLinks.sections.map((section) => (
            <div key={section.title}>
              <h3 className='font-heading text-sm font-bold text-background-50 mb-3 md:mb-4'>
                {section.title}
              </h3>
              <ul className='flex flex-col gap-2'>
                {section.links.map((link) => (
                  <li key={link}>
                    <a
                      href='#'
                      className='text-sm text-background-300 hover:text-primary-300 transition-colors'
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className='border-t border-background-700 pt-6 md:pt-8'>
          <div className='flex flex-col sm:flex-row items-center justify-between gap-4 mb-6'>
            <p className='text-xs text-background-400 text-center sm:text-left'>
              &copy; 2026 97在线影院 — 热门综艺节目在线观看平台。本站内容仅供学习交流，请支持正版综艺节目。
            </p>
            <div className='flex items-center gap-4'>
              <a href='#' className='text-background-400 hover:text-background-200 transition-colors text-sm'>
                <i className='ri-weibo-line'></i>
              </a>
              <a href='#' className='text-background-400 hover:text-background-200 transition-colors text-sm'>
                <i className='ri-wechat-line'></i>
              </a>
              <a href='#' className='text-background-400 hover:text-background-200 transition-colors text-sm'>
                <i className='ri-bilibili-line'></i>
              </a>
            </div>
          </div>

          <div className='border-t border-background-700 pt-4'>
            <h4 className='text-xs font-heading font-bold text-background-400 text-center mb-3'>
              合作伙伴
            </h4>
            <p className='text-xs text-background-500 text-center'>
              更多合作伙伴持续加入中
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}